import sha256 from 'sha256';

export function setTagsInDataLayer() {
  const $dsaBig = document.querySelector('#customDSABig');
  const $widgetForm = document.querySelector('.wg-form.wm_form-box');
  const $widgetFormMobile = document.querySelector('.wg-form.wm_formmobile-box.wg-form');
  const $phoneInput = document.querySelector('[name="telefono"]');
  const $privacyCheckbox = document.querySelector('#wmCheckBox');

  window.WALMERIC = {};

  // Evento para encriptar el valor del teléfono al perder el foco
  $phoneInput?.addEventListener('blur', (event) => {
    const { value } = event.target;
    window.WALMERIC.PHONE_VALUE = sha256(value);
  });

  // Intervalo para esperar el elemento y agregar el listener al botón
  const waitingForDFI = setInterval(() => {
    if ($dsaBig && !$dsaBig.listenerAdded) {
      $dsaBig.addEventListener('click', (event) => {
        window.dataLayer.push({
          event: 'proceso',
          tipoProceso: 'formulario-lead-sticky',
          paso: '1',
          tipoPaso: 'inicio',
          detallePaso: 'inicio-cmb',
          tipoInteraccion: 'envio',
          Resultado: 'ok',
          validacionDatos: 'NA',
          datos: 'NA'
        });
      });

      // Marcar que el listener ya fue añadido para evitar duplicados
      $dsaBig.listenerAdded = true;
      clearInterval(waitingForDFI);
    }

    if (typeof window.DFI !== 'undefined') {
      clearInterval(waitingForDFI);

      // Obtener el botón de envío del formulario en desktop y mobile
      const $submitButtonDesktop = $widgetForm?.querySelector('.wg-submit.wm_submit-btn');
      const $submitButtonMobile = $widgetFormMobile?.querySelector('.wg-submit.wm_submitmobile-btn.wg-input');

      // Listener para enviar en desktop y mobile
      const handleSubmit = (event) => {
        const $numberValidate = document.querySelector('.wg-error-telefono')?.textContent;

        // Validaciones de checkbox y teléfono
        if ($privacyCheckbox && !$privacyCheckbox.checked && $numberValidate === 'Introduzir um número de telefone válido') {
          ko();
        } else if ($privacyCheckbox && !$privacyCheckbox.checked && $numberValidate !== 'Introduzir um número de telefone válido') {
          koCheckBox();
        } else if ($privacyCheckbox && $privacyCheckbox.checked && $numberValidate === 'Introduzir um número de telefone válido') {
          koTelefono();
        } else {
          ok();
        }
      };

      // Agregar eventos para ambos botones, si están presentes
      $submitButtonDesktop?.addEventListener('click', handleSubmit);
      $submitButtonMobile?.addEventListener('click', handleSubmit);
    }
  }, 50);
}

// Funciones para disparar eventos de validación

function ko() {
  window.dataLayer.push({
    event: 'cmb',
    posicion: 'caja',
    cmbId: 'ib-cmb_form',
    leadId: window.Piwik.getAsyncTracker().getVisitorId(),
    campania: 'NA',
    proveedor: 'delio',
    telefonoCMB: window.WALMERIC.PHONE_VALUE,
    validacionDatos: 'debe-aceptar-las-condiciones|telefono-es-obligatorio',
    resultado: "ko"
  });
}

function koCheckBox() {
  window.dataLayer.push({
    event: 'cmb',
    posicion: 'caja',
    cmbId: 'ib-cmb_form',
    leadId: window.Piwik.getAsyncTracker().getVisitorId(),
    campania: 'NA',
    proveedor: 'delio',
    telefonoCMB: window.WALMERIC.PHONE_VALUE,
    validacionDatos: 'debe-aceptar-las-condiciones',
    resultado: "ko"
  });
}

function koTelefono() {
  window.dataLayer.push({
    event: 'cmb',
    posicion: 'caja',
    cmbId: 'ib-cmb_form',
    leadId: window.Piwik.getAsyncTracker().getVisitorId(),
    campania: 'NA',
    proveedor: 'delio',
    telefonoCMB: window.WALMERIC.PHONE_VALUE,
    validacionDatos: 'telefono-es-obligatorio',
    resultado: "ko"
  });
}

function ok() {
  window.dataLayer.push({
    event: 'cmb',
    posicion: 'caja',
    cmbId: 'ib-cmb_form',
    leadId: window.Piwik.getAsyncTracker().getVisitorId(),
    campania: 'NA',
    proveedor: 'delio',
    telefonoCMB: window.WALMERIC.PHONE_VALUE,
    validacionDatos: 'formulario-enviado-correctamente',
    resultado: "ok"
  });
}

// Función para cambiar el texto cuando la URL coincide
function cambiarTexto() {
  const aElement = document.querySelector('a.wm_ringpool-text');
  if (aElement && aElement.textContent === '800 60 60 60') {
    aElement.textContent = '800 181 102';
  }
}

// Observador de cambios en el DOM para cambiar el texto
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' || mutation.type === 'subtree') {
      if (window.location.href === 'https://www.iberdrola.pt/l/oferta/loja-do-condominio') {
        cambiarTexto();
      }
    }
  });
});

// Configuración del observador
const config = {
  childList: true,
  subtree: true
};

// Iniciamos el observador en el body del documento
observer.observe(document.body, config);

// Llamamos a la función directamente al cargar la página
if (window.location.href === 'https://www.iberdrola.pt/l/oferta/loja-do-condominio') {
  cambiarTexto();
}
